import {isProd} from '../env/enviroment';

export const loadPayeezyScript = () => {

  const script = document.createElement('script');
  if (isProd) {
    script.src = './scripts/payeezy-paymentjs-client-2.0.0-prod.js';
  }
  else{
    script.src = './scripts/payeezy-paymentjs-client-2.0.0.js';
  }

  script.async = true;
  document.body.appendChild(script);
};
